import type {Moment} from 'moment-timezone';

export const isEndDateValid = (endDate: Moment, startDate: Moment) => {
    return endDate.isAfter(startDate);
};
